import { useAuth0 } from '@auth0/auth0-react';
import { JitsuProvider as ReactJitsuProvider } from '@jitsu/jitsu-react';
import type { JitsuOptions } from '@jitsu/js';
import type { ReactNode } from 'react';

interface JitsuProviderProps {
  children: ReactNode;
}

const jitsuHost = process.env.JITSU_HOST ?? '';

// eslint-disable-next-line react/prop-types
const JitsuProvider: React.FC<JitsuProviderProps> = ({ children }) => {

  const { isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return (
      <ReactJitsuProvider
        options={{
          host: jitsuHost,
        } as JitsuOptions}
      >
        {children}
      </ReactJitsuProvider>
    );
  }

  return null;
};

export default JitsuProvider;
